export class SessionStorageUtils {
    static getItemsFromSessionStorage(cacheFiltro: string) {
        try {
            const items = globalThis.sessionStorage.getItem(cacheFiltro);
            return JSON.parse(items || 'null');
        }
        catch (err) {
            console.error(`Erro ao recuperar dados do sessionStorage para ${cacheFiltro}:`, err);
            return null;
        }
    }
}